import {Livewire, Alpine} from '../../vendor/livewire/livewire/dist/livewire.esm.js';
import AsyncAlpine from 'async-alpine';
import {Client} from 'typesense';
import './bootstrap'

import {createPopper} from '@popperjs/core';

window.Typesense = Client;
window.createPopper = createPopper;

import Fuse from 'fuse.js'

window.Fuse = Fuse;

window.Livewire = Livewire;
import VideoUpload from './filament/video-upload.js'
import mapboxAddressSearch from './mapbox-address-search.ts'

import 'livewire-sortable'

import './main'

import './tasks'
import './select-student'

import './single-combobox.ts'
import './single-search-input'
import './multi-combobox.ts'
import './calendar.tsx'
import './sentry'
import './radio-group.ts'
import './keep-durations.ts'
import './search.js'
import './team-cards.tsx'

document.addEventListener('alpine:init', () => {
    Alpine.plugin(AsyncAlpine);
    Alpine.asyncData('studentHeatmap', () => import('./student-heatmap.js'));
    Alpine.asyncData('typesenseSelect', () => import("./filament/typesense-select.js"));
    // Fall back to an unmasked input when the chunk cannot load (e.g. stale tab after a deploy); otherwise x-cloak hides the field forever.
    Alpine.asyncData('fixedDateMask', () => import('./fixed-date-mask.js').catch(() => () => ({})));
});
Alpine.data('videoUpload', VideoUpload);
Alpine.data('mapboxAddressSearch', mapboxAddressSearch);
Livewire.start()


document.addEventListener('trix-before-paste', function (e) {
    if (e.paste.hasOwnProperty('html')) {
        let div = document.createElement("div");
        div.innerHTML = e.paste.html;
        e.paste.html = div.textContent;
    }
});
